import {styled} from "@mui/material/styles"

export const LoadingIconPrevNextPageContainer = styled("div")`
    flex: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 5rem;
    margin: 2rem 0;
    img {
        width: 3rem;
        height: 3rem;
    }
`
